<template>
  <a-layout class="layout-container" :class="currentTheme">
    <!-- 顶部通栏 header：logo 常驻左侧，不随侧边栏收起切换位置（固定吸顶） -->
    <a-layout-header class="header">
      <div class="header-left">
        <div class="logo-wrapper">
          <img :src="logoImage" alt="Logo" class="logo-image" />
        </div>
        <span class="logo-text"
          >新知智法<span class="logo-text-two">AI法律助手</span></span
        >
      </div>

      <div class="header-right">
        <template v-if="hasToken">
          <div class="header-tools">
            <div class="tool-item" @click="goHistorys('purchaseplan')">
              <div class="enterprise">
                <img src="@/assets/icons/i-crown.png" alt="" />
                <!-- <span>企业版</span> -->
                <span class="days" v-if="isVip === true">企业版</span>
                <span class="days" v-else>普通用户</span>
                <span class="days" v-if="isVip === true">
                  于{{ expireTime }} 到期</span
                >
              </div>
            </div>

            <div class="tool-item" @click="goHistorys('collectindex')">
              <img src="@/assets/icons/i-star.png" alt="" />
              <span>我的收藏</span>
            </div>

            <div class="tool-item" @click="goHistorys('HistoryRecord')">
              <img src="@/assets/icons/i-history.png" alt="" />
              <span>历史记录</span>
            </div>
            <!-- 我的消息入口：铃铛图标已隐藏，整个入口先注释掉（含未读数角标），
                 恢复时放开此块并取消 i-bell.png 那行注释 -->
            <!-- <div class="tool-item" @click="goHistorys('my-message')">
              <div class="icon-wrapper">
                <img src="@/assets/icons/i-bell.png" alt="" />
                <span v-if="noReadCount > 0" class="badge">
                  {{ noReadCount > 99 ? "99+" : noReadCount }}
                </span>
              </div>
            </div> -->
          </div>
          <a-dropdown>
            <div class="user-info">
              <template v-if="userAvatarUrl">
                <a-avatar
                  class="user-avatar"
                  :src="userAvatarUrl"
                  :style="{ background: 'transparent' }"
                />
              </template>
              <template v-else>
                <a-avatar class="user-avatar">
                  {{ userInfo.nickName?.slice(0, 1) }}
                </a-avatar>
              </template>
              <!-- <span class="user-name">{{ userInfo.name }}</span> -->
            </div>
            <template #overlay>
              <a-menu class="user-menu">
                <a-menu-item @click="handleUserInfo" key="profile">
                  <UserOutlined />
                  个人中心
                </a-menu-item>
                <!-- <a-menu-item key="settings">
                  <SettingOutlined />
                  设置
                </a-menu-item> -->
                <a-menu-divider />
                <a-menu-item key="logout" @click="handleLogout">
                  <LogoutOutlined />
                  退出登录
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
        <!-- 无token 展示登录按钮 -->
        <template v-else>
          <a-button type="primary" @click="router.push('/NumberLogin')"
            >登录</a-button
          >
        </template>
      </div>
    </a-layout-header>

    <!-- 下方：侧边栏 + 内容区（margin-top 让位固定 header，见 .body-layout 样式） -->
    <a-layout class="body-layout">
      <!-- 左侧导航栏（固定在 header 正下方，不占文档流宽度，宽度让位靠 main-layout） -->
      <a-layout-sider
        v-model:collapsed="collapsed"
        :trigger="null"
        collapsible
        class="sider"
        width="264"
      >
        <div class="menu-wrapper">
          <a-menu
            v-model:selectedKeys="selectedKeys"
            v-model:openKeys="openKeys"
            :theme="menuTheme"
            mode="inline"
            @click="handleMenuClick"
          >
            <template v-for="menu in visibleMenuList" :key="menu.key">
              <!-- 有子菜单 -->
              <a-sub-menu
                v-if="menu.children && menu.children.length > 0"
                :key="`sub-${menu.key}`"
                @titleClick="handleParentMenuClick(menu)"
                :class="{
                  'parent-menu-selected': isParentMenuSelected(menu.key),
                }"
              >
                <template #icon>
                  <SvgIcon :name="menu.icon" :size="18" class="menu-icon" />
                </template>

                <!-- 不加自定义 tooltip，收起态提示走 antd 菜单默认行为 -->
                <template #title>
                  <span
                    @mouseenter="handleParentMouseEnter(menu.key)"
                    @mouseleave="handleParentMouseLeave(menu.key)"
                  >
                    {{ menu.title }}
                  </span>
                </template>

                <template v-for="child in menu.children" :key="child.key">
                  <a-menu-item>
                    {{ child.title }}
                  </a-menu-item>
                </template>
              </a-sub-menu>

              <!-- 无子菜单 -->
              <a-menu-item v-else :key="menu.key">
                <template #icon>
                  <SvgIcon :name="menu.icon" :size="18" class="menu-icon" />
                </template>

                {{ menu.title }}
              </a-menu-item>
            </template>
          </a-menu>
        </div>
        <!-- 手动展开/收起侧边栏：骑缝悬浮在侧边栏右上边缘，
             收起态图标转 180 度（默认左向 = 可收起） :size="16" -->
        <a-tooltip
          :title="collapsed ? '展开侧边栏' : '收起侧边栏'"
          placement="right"
        >
          <div class="sider-toggle" @click="toggleCollapse">
            <SvgIcon
              name="toggle"
              :size="32"
              class="sider-toggle-icon"
              :class="{ 'sider-toggle-icon-rotated': collapsed }"
            />
          </div>
        </a-tooltip>
        <img
          v-if="!collapsed"
          src="@/assets/homeImg/icon1.png"
          class="icons-vip"
          :style="{ bottom: hasToken ? '110px' : '0px' }"
          @click="goHistorys('purchaseplan')"
        />
        <!-- 收起态：小号圆形皇冠图标，点击同样进入套餐页 -->
        <img
          v-else
          src="@/assets/homeImg/icon-m.svg"
          class="icons-vip-collapsed"
          :style="{ bottom: hasToken ? '110px' : '0px' }"
          @click="goHistorys('purchaseplan')"
        />
        <!-- 底部用户信息 -->
        <div class="sider-user" v-if="hasToken">
          <a-dropdown placement="topRight">
            <div class="user-card">
              <template v-if="userAvatarUrl">
                <a-avatar
                  class="user-avatar"
                  :src="userAvatarUrl"
                  :style="{ background: 'transparent' }"
                />
              </template>
              <template v-else>
                <a-avatar class="user-avatar">
                  {{ userInfo.nickName?.slice(0, 1) }}
                </a-avatar>
              </template>

              <template v-if="!collapsed">
                <div class="user-content">
                  <div class="user-name">
                    {{ userInfo.nickName }}
                  </div>
                  <div class="user-company">
                    <span class="user-bb" v-if="isVip">企业版</span>
                    <span class="user-bb" v-else>普通用户</span>
                    <span v-if="isVip"> 于{{ expireTime }} 到期</span>
                  </div>
                </div>
              </template>
            </div>

            <template #overlay>
              <a-menu>
                <a-menu-item @click="handleUserInfo"> 个人中心 </a-menu-item>
                <a-menu-item @click="handleLogout"> 退出登录 </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-sider>

      <!-- 右侧内容区域（margin-left 让位固定侧边栏，收展切换见 .main-layout 样式） -->
      <a-layout
        class="main-layout"
        :class="{ 'main-layout-collapsed': collapsed }"
      >
        <!-- 标签页导航 -->
        <div class="tab-navigation" v-if="openTabs.length < 0">
          <div class="tab-list">
            <div
              v-for="tab in openTabs"
              :key="tab.key"
              class="tab-item"
              :class="{ active: activeTabKey === tab.key }"
              @click="handleTabClick(tab.key)"
            >
              <span class="tab-title">{{ tab.title }}</span>
              <span
                v-if="tab.closable"
                class="tab-close"
                @click.stop="closeTab(tab.key)"
              >
                <CloseOutlined />
              </span>
              <a-dropdown class="tab-action" :trigger="['hover']" @click.stop>
                <MoreOutlined />
                <template #overlay>
                  <a-menu>
                    <a-menu-item key="refresh" @click="refreshTab(tab.key)">
                      <ReloadOutlined /> 刷新当前页
                    </a-menu-item>
                    <a-menu-item
                      key="closeOther"
                      @click="closeOtherTabs(tab.key)"
                      v-if="openTabs.length > 1"
                    >
                      <CloseSquareOutlined /> 关闭其他
                    </a-menu-item>
                    <a-menu-item
                      key="closeAll"
                      @click="closeAllTabs"
                      v-if="openTabs.length > 1"
                    >
                      <MinusSquareOutlined /> 关闭所有
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </div>
        </div>

        <!-- 主要内容 -->
        <a-layout-content class="content">
          <div class="content-wrapper">
            <!-- 内容区统一滑入滑出过渡：标签页切换 / 路由跳转都触发 -->
            <transition name="content-slide" mode="out-in">
              <!-- 标签页内容区域 - 只渲染当前活跃的标签页；activeTab 不存在（如首页按钮直接路由跳转）时回退 router-view -->
              <div
                v-if="openTabs.length > 0 && activeTabKey && activeTab"
                :key="`tab-${activeTabKey}`"
                class="tab-content"
              >
                <component
                  v-if="activeTab"
                  ref="activeComponentRef"
                  :is="getComponentByKey(activeTab.key)"
                />
              </div>
              <!-- 无标签页时显示默认内容（按路径 keyed，路径变化时触发过渡） -->
              <div v-else :key="`route-${router.currentRoute.value.path}`">
                <router-view />
              </div>
            </transition>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  provide,
  onMounted,
  onUnmounted,
  watch,
} from "vue";
import {
  UserOutlined,
  LogoutOutlined,
  CloseOutlined,
  ReloadOutlined,
  MoreOutlined,
  CloseSquareOutlined,
  MinusSquareOutlined,
} from "@ant-design/icons-vue";
import { GetMyNoReadCount, GetCurrentUserVipInfo } from "@/api/message";
//import { Button } from 'ant-design-vue';
import { useRouter } from "vue-router";
import "../css/kevinHome.css";
import hedeImage from "../assets/hede.png"; // 导入用户头像图片
import logoImage from "@/assets/homeImg/logo.png"; // 导入logo图片
// import MenuIcon from "@/components/icons/MenuIcon.vue";

// 导入页面组件
import UserList from "./UserList.vue";
import UserRole from "./UserRole.vue";
import PermissionMg from "./PermissionMg.vue";
import DicConfig from "./DicMg.vue";
import SystemAnnouncement from "./SystemAnnouncement.vue";
import HttpLogMg from "./HttpLog.vue";
import OSLogMG from "./OSLog.vue";
import AiAppsMg from "./ai/AgentManagement.vue";
import AiPromptsMg from "./ai/PromptManagement.vue";
import AiKmssMg from "./ai/KnowledgeBaseManagement.vue";
import AiModelMg from "./ai/ModelManagement.vue";
import AiSkillToolMg from "./ai/SkillToolManagement.vue";
import MyMessages from "./MyMessages.vue";
import MyAIChat from "./ai/MyAIChat.vue";
import MyAITasks from "./ai/MyAITasks.vue";
import MyAgentList from "./ai/MyAgentList.vue";
import PositionManagement from "./organizational/PositionManagement.vue";
import DepartmentManagement from "./organizational/DepartmentManagement.vue";
import TenantManagement from "./TenantManagement.vue";
import CodeGenerator from "./CodeGenerator.vue";
// import KevinDashboard from "./kevinDashboard.vue";
// import UserProfile from "./UserProfile.vue";
import LegalPortal from "./LegalPortal.vue";
import ContractReview from "./ContractReview/index.vue";
import JudicativePaper from "./JudicativePaper/index.vue";
// 要素式文书
import ElementBased from "./ElementBased/index.vue";
import SearchHome from "@/components/casesearch/SearchHome.vue";
import DocumentHome from "@/components/documenthome/DocumentHome.vue";
import HistoryRecord from "./HistoryRecord.vue";
import CollectIndex from "@/components/collect/CollectIndex.vue";
// 历史记录
import PersonalCenter from "@/pages/PersonalCenter/PersonalCenter.vue";
// vip套餐
import PurchasePlan from "@/pages/PurchasePlan/PurchasePlan.vue";
import UnderDevelopment from "@/pages/UnderDevelopment.vue";
// 默认首页（我的工作台内容区）
import DefaultHome from "@/pages/DefaultHome/index.vue";
import { message } from "ant-design-vue";
const router = useRouter();

// 侧边栏收起策略：合同审查/裁判文书结果页（内容过多的沉浸式页面）进入时自动收起；
// 文书生成、法律检索报告页路由不变，由页面内部状态经 collapseSider 触发收起；
// 其余页面（含 /home）默认展开
const AUTO_COLLAPSE_PATHS = [
  "/home/contract-review/result",
  "/home/JudicativePaper/result",
  "/home/ElementBased/generateResults",
];
const isAutoCollapseRoute = (path) => AUTO_COLLAPSE_PATHS.includes(path);
const collapsed = ref(isAutoCollapseRoute(router.currentRoute.value.path));

// 按目标路由统一设定侧边栏收展状态。
// 路由只会"收起"不会"展开"：进入固定收起页（合同审查结果页）自动收起；
// 离开时保持当前状态（手动收起的不再自动展开），展开只能通过骑缝按钮。
// 也不碰 openKeys——子菜单开合跟随用户点击/悬停，初始默认全开由 onMounted
// 的 expandAllMenus 负责
const applySidebarState = (path) => {
  if (isAutoCollapseRoute(path)) {
    collapsed.value = true;
  }
};

// 手动展开/收起（sider-toggle 按钮）；子菜单开合同样不重置
const toggleCollapse = () => {
  collapsed.value = !collapsed.value;
};

// 供页面内部状态触发侧边栏自动收起（路由不变的场景，
// 如法律检索进入报告生成/查看步骤）。语义与路由规则一致：只收起不展开
provide("collapseSider", () => {
  collapsed.value = true;
});

// /home（DefaultHome）页面自带备案信息，隐藏壳层底部 footer
// const isDefaultHome = computed(
//   () => router.currentRoute.value.path === "/home",
// );

// 根据路由路径反查菜单 key（与 handleMenuClick 中的 switch 映射保持一致）
const routeToMenuKey = {
  "/home/user/list": "user-list",
  "/home/user/role": "user-role",
  "/home/user/permission": "user-permission",
  "/home/system/dic": "system-dic",
  "/home/system/announcement": "system-announcement",
  "/home/my/message": "my-message",
  "/home/my/ai-chat": "my-ai-chat",
  "/home/my/ai-tasks": "my-ai-tasks",
  "/home/my/ai-agents": "my-ai-agents",
  "/home/system/log": "log-management",
  "/home/system/oslog": "oslog",
  "/home/aimanagement": "aimanagement",
  "/home/aimanagement/aiappsmg": "ai-appsmg",
  "/home/aimanagement/aipromptsmg": "ai-promptsmg",
  "/home/aimanagement/aikmssmg": "ai-kmssmg",
  "/home/aimanagement/aimodelmg": "ai-modelmg",
  "/home/aimanagement/aiskilltoolmg": "ai-skilltoolmg",
  "/home/position/management": "organizational-position",
  "/home/department/management": "organizational-department",
  "/home/system/tenant": "system-tenant",
  "/home/system/code-generator": "system-code-generator",
  "/home/legal/portal": "legal-portal",
  "/home/contract-review": "legal-portal1",
  "/home/JudicativePaper": "ai-cpws",
  "/home/ElementBased": "ai-yssws",
  "/home": "dashboard",
  "/home/HistoryRecord": "HistoryRecord",
  "/home/CollectIndex": "collectindex",
  "/home/PurchasePlan": "purchaseplan",
  "/home/PersonalCenter": "handleUserInfo",
  "/home/SearchHome": "aiselect",
  "/home/DocumentHome": "aikmssmg",
};

const initSelectedKey = () => {
  const path = router.currentRoute.value.path;
  return routeToMenuKey[path] || "dashboard";
};
const selectedKeys = ref([initSelectedKey()]);

// 先初始化为空数组，menuListNew 定义后会在 onMounted 中展开
const openKeys = ref([]);

// 全局注册历史记录数据回调，供 SearchHome 组件使用
window.__historyRecordData = null;

// 提供给子组件的 goCase 方法
provide("goCase", (key, detail) => {
  if (key === "aiselect") {
    window.__historyRecordData = detail;
  }
  if (key === "aikmssmg") {
    window.__historyIndictmentData = detail;
  }
  if (!detail) {
    return;
  }
  const nameMap = {
    aiselect: { key: "aiselect", title: "类案检索" },
    aikmssmg: { key: "aikmssmg", title: "诉讼文书" },
    "my-ai-chat": { key: "my-ai-chat", title: "我的AI对话" },
  };
  const match = nameMap[key] || { key: "aiselect", title: "类案检索" };
  // 设置左侧菜单选中状态
  selectedKeys.value = [match.key];
  // 如果该菜单有父级 sub-menu，展开它
  const parentSubKey = `sub-${match.key}`;
  if (!openKeys.value.includes(parentSubKey)) {
    openKeys.value.push(parentSubKey);
  }
  openTab(match.key, match.title);
  // 类案检索/诉讼文书：目标组件挂载后恢复历史数据。
  // 内容区切换有 out-in 滑动过渡（约 0.28s），组件要等过渡结束才真正挂载，
  // 固定延时可能取到旧组件或空 ref，改为轮询等待目标组件就绪后再恢复
  if (key === "aiselect" || key === "aikmssmg") {
    const getData = () =>
      key === "aiselect"
        ? window.__historyRecordData
        : window.__historyIndictmentData;
    const clearData = () => {
      if (key === "aiselect") {
        window.__historyRecordData = null;
      } else {
        window.__historyIndictmentData = null;
      }
    };
    const tryRestore = (retries = 12) => {
      if (
        activeTabKey.value === match.key &&
        activeComponentRef.value?.restoreFromHistory
      ) {
        const data = getData();
        clearData();
        activeComponentRef.value.restoreFromHistory(data);
        return;
      }
      if (retries > 0) {
        setTimeout(() => tryRestore(retries - 1), 100);
      }
    };
    tryRestore();
  }
});

const isHoveringParent = ref({});
const parentMenuSelected = ref("");

// 菜单列表（是否显示由 visibleMenuList 计算属性过滤：常驻菜单 + 接口权限，这里只声明结构）
const menuListNew = ref([
  {
    key: "dashboard",
    title: "首页",
    icon: "home",
    permission: "Menu/Home",
  },
  {
    key: "aiselect",
    title: "AI 法律检索",
    icon: "searching",
    permission: "Menu/MyMenu",
  },
  {
    key: "aigenerate",
    title: "AI 文书生成",
    icon: "writ",
    permission: "Menu/AIManagement/AIAppsManagement",
    children: [
      {
        key: "ai-yssws",
        title: "要素式文书",
        permission: "Menu/AIManagement/AIAppsManagement",
      },
      {
        key: "ai-cpws",
        title: "裁判文书",
        permission: "Menu/AIManagement/AIPromptsManagement",
      },
      {
        key: "aikmssmg",
        title: "诉讼文书",
        permission: "Menu/AIManagement/AIKmssManagement",
      },
      {
        key: "ai-fsws",
        title: "非诉文书",
        permission: "Menu/AIManagement/AIModelManagement",
      },
    ],
  },
  {
    key: "danger",
    title: "AI 风控审查",
    icon: "control",
    permission: "Menu/AIManagement/AIAppsManagement",
    children: [
      {
        key: "legal-portal1",
        title: "合同审查",
        permission: "Menu/AIManagement/AIAppsManagement",
      },
      {
        key: "ai-wjsc",
        title: "文件审查",
        permission: "Menu/AIManagement/AIModelManagement",
      },
    ],
  },
  {
    key: "HistoryRecord",
    title: "历史任务",
    icon: "history",
    permission: "Menu/HistoryRecord",
  },
  {
    key: "collectindex",
    title: "我的收藏",
    icon: "collect",
    permission: "Menu/Collectindex",
  },
  {
    key: "my",
    title: "我的",
    icon: "my",
    permission: "Menu/MyMenu",
    children: [
      {
        key: "my-message",
        title: "我的消息",
        permission: "Menu/MyMenu/MyMessage",
      },
      {
        key: "my-ai-chat",
        title: "我的AI对话",
        permission: "Menu/MyMenu/MyAiChat",
      },
      {
        key: "my-ai-tasks",
        title: "我的AI自动任务",
        permission: "Menu/MyMenu/MyAiTasks",
      },
      {
        key: "my-ai-agents",
        title: "我的可用智能体",
        permission: "Menu/MyMenu/MyAiAgents",
      },
    ],
  },
  {
    key: "aimanagement",
    title: "AI管理",
    icon: "robot",
    permission: "Menu/AIManagement",
    children: [
      {
        key: "ai-appsmg",
        title: "智能体管理",
        permission: "Menu/AIManagement/AIAppsManagement",
      },
      {
        key: "ai-promptsmg",
        title: "提示词管理",
        permission: "Menu/AIManagement/AIPromptsManagement",
      },
      {
        key: "ai-kmssmg",
        title: "知识库管理",
        permission: "Menu/AIManagement/AIKmssManagement",
      },
      {
        key: "ai-modelmg",
        title: "模型配置管理",
        permission: "Menu/AIManagement/AIModelManagement",
      },
      {
        key: "ai-skilltoolmg",
        title: "AI技能工具管理",
        permission: "Menu/AIManagement/AISkillToolManagement",
      },
    ],
  },
  {
    key: "legal-portal-group",
    title: "法律应用",
    icon: "scale",
    permission: "Menu/LegalApps",
    children: [
      {
        key: "legal-portal",
        title: "法律应用门户",
        permission: "Menu/LegalApps/Portal",
      },
    ],
  },
  {
    key: "organizational-management",
    title: "组织架构",
    icon: "org",
    permission: "Menu/OrganizationalManagement",
    children: [
      {
        key: "organizational-position",
        title: "岗位管理",
        permission: "Menu/OrganizationalManagement/PositionManagement",
      },
      {
        key: "organizational-department",
        title: "部门管理",
        permission: "Menu/OrganizationalManagement/DepartmentManagement",
      },
    ],
  },
  {
    key: "user-management",
    title: "用户管理",
    icon: "user",
    permission: "Menu/UserManagement",
    children: [
      {
        key: "user-list",
        title: "用户列表",
        permission: "Menu/UserManagement/UserList",
      },
      {
        key: "user-role",
        title: "角色管理",
        permission: "Menu/UserManagement/UserRole",
      },
      {
        key: "user-permission",
        title: "权限管理",
        permission: "Menu/UserManagement/UserPermission",
      },
    ],
  },
  {
    key: "system-settings",
    title: "系统管理",
    icon: "system",
    permission: "Menu/SystemSettings",
    children: [
      {
        key: "system-announcement",
        title: "系统公告",
        permission: "Menu/SystemSettings/SystemAnnouncement",
      },
      {
        key: "system-dic",
        title: "系统配置",
        permission: "Menu/SystemSettings/SystemDic",
      },
      {
        key: "system-tenant",
        title: "租户管理",
        permission: "Menu/SystemSettings/SystemTenant",
      },
      {
        key: "system-code-generator",
        title: "代码生成器",
        permission: "Menu/SystemSettings/SystemCodeGenerator",
      },
      {
        key: "log-management",
        title: "日志管理",
        permission: "Menu/SystemSettings/LogManagement",
      },
      {
        key: "oslog",
        title: "关键数据变动日志",
        permission: "Menu/SystemSettings/OsLog",
      },
    ],
  },
]);
onMounted(() => {
  // 其它代码...

  if (!collapsed.value) {
    expandAllMenus();
  }
});
// const historyCount = ref(12)

// ----新增：路由跳转前置校验函数----
/**
 * @param targetPath 要跳转的目标路径
 * @returns true允许跳转 false拦截
 */
const checkTokenBeforeJump = (targetPath) => {
  // 首页直接放行
  if (targetPath === "/home") {
    return true;
  }
  // 非首页，无token
  if (!hasToken.value) {
    message.warning("请先登录");
    router.push("/NumberLogin");
    return false;
  }
  return true;
};
const goHistorys = (key) => {
  // 开发中的文书子菜单特殊处理（未登录回首页/已登录显示"持续上线中"）
  if (DEV_DOC_MENU_KEYS.includes(key)) {
    handleDevDocMenu(key);
    return;
  }
  // =========新增校验=========
  const targetPath = getRoutePath(key);
  if (!checkTokenBeforeJump(targetPath)) {
    return;
  }
  // =========================

  // console.log(key,'keys2')
  selectedKeys.value = [key];
  activeTabKey.value = [key];
  // 获取页面标题
  const title = pageTitleMap[key] || key;
  if (key === "dashboard") {
    goDashboard();
    openTab(key, title);
    return;
  }
  // console.log(selectedKeys.value,title,'46283')
  // 打开标签页
  openTab(key, title);
  // console.log(key, title,'key, title')
  // 根据key跳转到对应路由
  switch (key) {
    case "user-list":
      router.push("/home/user/list");
      break;
    case "user-role":
      router.push("/home/user/role");
      break;
    case "user-permission":
      router.push("/home/user/permission");
      break;
    case "system-dic":
      router.push("/home/system/dic");
      break;
    case "system-announcement":
      router.push("/home/system/announcement");
      break;
    case "my-message":
      router.push("/home/my/message");
      break;
    case "my-ai-chat":
      router.push("/home/my/ai-chat");
      break;
    case "my-ai-tasks":
      router.push("/home/my/ai-tasks");
      break;
    case "my-ai-agents":
      router.push("/home/my/ai-agents");
      break;
    case "log-management":
      router.push("/home/system/log");
      break;
    case "oslog":
      router.push("/home/system/oslog");
      break;
    case "aimanagement":
      router.push("/home/aimanagement");
      break;
    case "ai-appsmg":
      router.push("/home/aimanagement/aiappsmg");
      break;
    case "ai-promptsmg":
      router.push("/home/aimanagement/aipromptsmg");
      break;
    case "ai-kmssmg":
      router.push("/home/aimanagement/aikmssmg"); // 添加知识库管理路由
      break;
    case "ai-modelmg":
      router.push("/home/aimanagement/aimodelmg");
      break;
    case "ai-skilltoolmg":
      router.push("/home/aimanagement/aiskilltoolmg");
      break;
    case "organizational-position":
      router.push("/home/position/management");
      break;
    case "organizational-department":
      router.push("/home/department/management");
      break;
    case "system-tenant":
      router.push("/home/system/tenant");
      break;
    case "system-code-generator":
      router.push("/home/system/code-generator");
      break;
    case "legal-portal":
      router.push("/home/legal/portal");
      break;
    case "legal-portal1":
      router.push("/home/contract-review");
      break;
    case "dashboard":
      router.push("/home");
      break;
    case "handleUserInfo":
      router.push("/home/PersonalCenter");
      break;
    case "HistoryRecord":
      // getComponentByKey(key)
      router.push("/home/HistoryRecord");
      break;
    case "collectindex":
      // getComponentByKey(key)
      router.push("/home/CollectIndex");
      break;
    case "purchaseplan":
      // getComponentByKey(key)
      router.push("/home/PurchasePlan");
      break;
    case "aiselect":
      // getComponentByKey(key)
      router.push("/home/SearchHome");
      break;
    case "aikmssmg":
      // getComponentByKey(key)
      router.push("/home/DocumentHome");
      break;
    case "ai-yssws":
      router.push("/home/ElementBased");
      break;
    case "ai-cpws":
      router.push("/home/JudicativePaper");
      break;
    case "ai-htsc":
      router.push("/home/UnderDevelopment");
      break;
    default:
      router.push("/home");
  }
};
// 在我的工作台时展开所有有子菜单的父菜单
const expandAllMenus = () => {
  const allParentKeys = menuListNew.value
    .filter((menu) => menu.children && menu.children.length > 0)
    .map((menu) => `sub-${menu.key}`);
  openKeys.value = allParentKeys;
};
// collapsed / openKeys 状态统一由 applySidebarState 与路由 watch 维护
const goDashboard = () => {
  applySidebarState("/home");
  selectedKeys.value = ["dashboard"];
  router.push("/home");
};

// 无内容的开发中子菜单（AI 文书生成下的非诉文书，AI 风控审查下的文件审查）：
// 未登录点击跳转登录页；已登录跳"持续上线中"页（/home/underdevelopment）
const DEV_DOC_MENU_KEYS = ["ai-fsws", "ai-wjsc"];
const handleDevDocMenu = (key) => {
  // 未登录：提示并跳转登录页（与其他受保护菜单一致，不改变选中状态）
  if (!hasToken.value) {
    message.warning("请先登录");
    router.push("/NumberLogin");
    return;
  }
  selectedKeys.value = [key];
  router.push("/home/underdevelopment");
};
// 收缩所有菜单
// const collapseAllMenus = () => {
//   openKeys.value = [];
// };

// 监听selectedKeys变化来控制菜单展开/收缩

// 标签页相关
const openTabs = ref([]);
const activeTabKey = ref("");

// 当前活跃的组件实例 ref（goCase 恢复历史记录时调用其 restoreFromHistory）
const activeComponentRef = ref(null);

// 监听路由变化：菜单页面（在 routeToMenuKey 中）激活对应标签页；
// 子页面（如合同审查的 requirements/result/list，不在映射中）清空 activeTabKey，
// 让内容区走 <router-view> 渲染真实页面，而不是停在 tab 组件上
watch(
  () => router.currentRoute.value.path,
  (newPath) => {
    // =========新增全局路由校验=========
    if (newPath !== "/home") {
      if (!hasToken.value) {
        message.warning("请先登录");
        router.push("/NumberLogin");
        return;
      }
    }
    // =================================
    // 侧边栏状态统一由路由决定：文书生成/合同审查自动收起，其余展开
    applySidebarState(newPath);
    const menuKey = routeToMenuKey[newPath];
    if (menuKey) {
      activeTabKey.value = menuKey;
      // 程序化导航（如首页按钮跳转）时同步侧边栏状态，效果与点击侧边栏菜单一致：
      // 选中对应菜单项并打开标签页。
      // 点击侧边栏菜单时 handleMenuClick 已设置过这些状态，此处跳过避免重复刷新。
      if (menuKey !== "dashboard" && selectedKeys.value[0] !== menuKey) {
        selectedKeys.value = [menuKey];
        openTab(menuKey, pageTitleMap[menuKey] || menuKey);
      }
    } else {
      activeTabKey.value = "";
    }
  },
);
// 有子集的父菜单：悬停展开/收起子菜单，不选中不路由
const handleParentMenuClick = (menu) => {
  parentMenuSelected.value = menu.key;
  // 仅切换子菜单展开/收起（hover自动展开，但收起仍需要点击）
  const subMenuKey = `sub-${menu.key}`;
  if (!openKeys.value.includes(subMenuKey)) {
    openKeys.value = [...openKeys.value, subMenuKey];
  } else {
    openKeys.value = openKeys.value.filter((k) => k !== subMenuKey);
  }
  // 不选中、不打开标签页、不跳转路由——只有叶子节点才能被选中
};
// const goEnterprise = () => {
//   console.log('企业版')
// }

// const goCollection = () => {
//   getComponentByKey('collectindex')
// }

// const goHistory = () => {
//   console.log('历史记录')
// }
// 鼠标悬停父菜单
const handleParentMouseEnter = (key) => {
  isHoveringParent.value[key] = true;
};

// 鼠标离开父菜单
const handleParentMouseLeave = (key) => {
  isHoveringParent.value[key] = false;
};

// 标签页相关

// 路由key到组件的映射
const routeComponentMap = {
  dashboard: DefaultHome,

  aiselect: SearchHome,
  aikmssmg: DocumentHome,
  "ai-yssws": ElementBased,
  "ai-cpws": JudicativePaper,
  "ai-fsws": UnderDevelopment,
  "ai-htsc": UnderDevelopment,
  "ai-wjsc": UnderDevelopment,
  HistoryRecord: HistoryRecord,
  collectindex: CollectIndex,
  purchaseplan: PurchasePlan,
  "user-list": UserList,
  "user-role": UserRole,
  "user-permission": PermissionMg,
  "system-dic": DicConfig,
  "system-announcement": SystemAnnouncement,
  "log-management": HttpLogMg,
  oslog: OSLogMG,
  "ai-appsmg": AiAppsMg,
  "ai-promptsmg": AiPromptsMg,
  "ai-kmssmg": AiKmssMg,
  "ai-modelmg": AiModelMg,
  "ai-skilltoolmg": AiSkillToolMg,
  "my-message": MyMessages,
  "my-ai-chat": MyAIChat,
  "my-ai-tasks": MyAITasks,
  "my-ai-agents": MyAgentList,
  "organizational-position": PositionManagement,
  "organizational-department": DepartmentManagement,
  "system-tenant": TenantManagement,
  "system-code-generator": CodeGenerator,
  handleUserInfo: PersonalCenter,
  "legal-portal": LegalPortal,
  "legal-portal1": ContractReview,
};

// 计算当前活动的标签页
const activeTab = computed(() => {
  // console.log(openTabs.value.find(tab => tab.key === activeTabKey.value),'openTabs.value.find(tab => tab.key === activeTabKey.value)')
  return openTabs.value.find((tab) => tab.key === activeTabKey.value);
});

// 根据key获取组件
const getComponentByKey = (key) => {
  // console.log(key,'key')
  return routeComponentMap[key] || null;
};

// 检查父菜单是否被选中（直接点击父菜单时）
const isParentMenuSelected = (parentKey) => {
  const currentKey = selectedKeys.value[0];
  return currentKey === parentKey;
};

// 页面标题映射
const pageTitleMap = {
  "user-list": "用户列表",
  "user-role": "角色管理",
  "user-permission": "权限管理",
  "system-dic": "系统配置",
  "system-announcement": "系统公告",
  "log-management": "日志管理",
  oslog: "关键数据变动日志",
  "ai-appsmg": "智能体管理",
  "ai-promptsmg": "提示词管理",
  "ai-kmssmg": "知识库管理",
  "ai-modelmg": "模型配置管理",
  "ai-skilltoolmg": "AI技能工具管理",
  "my-message": "我的消息",
  "my-ai-chat": "我的AI对话",
  "my-ai-tasks": "我的AI自动任务",
  "my-ai-agents": "我的可用智能体",
  "organizational-position": "岗位管理",
  "organizational-department": "部门管理",
  "system-tenant": "租户管理",
  "system-code-generator": "代码生成器",
  dashboard: "首页",
  handleUserInfo: "个人中心",
  "legal-portal": "法律应用",
  "legal-portal1": "合同审查",
  "ai-cpws": "裁判文书",
  "ai-yssws": "要素式文书",
};

// 打开标签页
const openTab = (key, title) => {
  // 如果页面已经打开，则激活并刷新
  const existingTab = openTabs.value.find((tab) => tab.key === key);
  // console.log(activeTabKey.value,openTabs,'activeTabKey.value')
  if (existingTab) {
    activeTabKey.value = key;
    // 刷新页面
    refreshTab(key);
    return;
  }

  // 添加新标签页
  const newTab = {
    key: key,
    title: title,
    closable: true,
    cacheKey: routeComponentMap[key] || key,
    refreshKey: Date.now(),
  };
  openTabs.value.push(newTab);
  activeTabKey.value = key;
};

// 关闭标签页
const closeTab = (key) => {
  const index = openTabs.value.findIndex((tab) => tab.key === key);
  if (index === -1) return;

  // 如果关闭的是当前激活的标签，切换到上一个或下一个
  if (activeTabKey.value === key) {
    const nextTab = openTabs.value[index + 1] || openTabs.value[index - 1];
    if (nextTab) {
      activeTabKey.value = nextTab.key;
      // 路由到下一个页面
      router.push(getRoutePath(nextTab.key));
    } else {
      activeTabKey.value = "";
    }
  }

  // 移除标签页
  openTabs.value.splice(index, 1);
};

// 根据key获取路由路径
const getRoutePath = (key) => {
  const paths = {
    "user-list": "/home/user/list",
    "user-role": "/home/user/role",
    "user-permission": "/home/user/permission",
    "system-dic": "/home/system/dic",
    "system-announcement": "/home/system/announcement",
    "log-management": "/home/system/log",
    oslog: "/home/system/oslog",
    "ai-appsmg": "/home/aimanagement/aiappsmg",
    "ai-promptsmg": "/home/aimanagement/aipromptsmg",
    "ai-kmssmg": "/home/aimanagement/aikmssmg",
    "ai-modelmg": "/home/aimanagement/aimodelmg",
    "ai-skilltoolmg": "/home/aimanagement/aiskilltoolmg",
    "my-message": "/home/my/message",
    "my-ai-chat": "/home/my/ai-chat",
    "my-ai-tasks": "/home/my/ai-tasks",
    "my-ai-agents": "/home/my/ai-agents",
    "organizational-position": "/home/position/management",
    "organizational-department": "/home/department/management",
    "system-tenant": "/home/system/tenant",
    "system-code-generator": "/home/system/code-generator",
    handleUserInfo: "/home/PersonalCenter",
    "legal-portal": "/home/legal/portal",
    "legal-portal1": "/home/contract-review",
    "ai-cpws": "/home/JudicativePaper",
    "ai-yssws": "/home/ElementBased",
    SearchHome: "/home/SearchHome",
    HistoryRecord: "/home/HistoryRecord",

    PurchasePlan: "/home/PurchasePlan",
  };
  return paths[key] || "/home";
};

// 刷新单个标签页
const refreshTab = (key) => {
  const tab = openTabs.value.find((t) => t.key === key);
  if (tab) {
    // 更新refreshKey来触发组件重新渲染
    tab.refreshKey = Date.now();
    activeTabKey.value = key;
  }
};

// 关闭其他标签页
const closeOtherTabs = (key) => {
  openTabs.value = openTabs.value.filter(
    (tab) => tab.key === key || !tab.closable,
  );
  activeTabKey.value = key;
};

// 关闭所有标签页
const closeAllTabs = () => {
  openTabs.value = openTabs.value.filter((tab) => !tab.closable);
  activeTabKey.value = "";
};

// Tab点击事件
const handleTabClick = (key) => {
  activeTabKey.value = key;
  router.push(getRoutePath(key));
};

const currentTheme = ref("theme-simple-white");

const menuTheme = computed(() => {
  return currentTheme.value === "theme-simple-white" ? "light" : "dark";
});

// 用户信息
const userInfo = reactive({
  nickName: "管理员",
  avatar: hedeImage,
});
// 头像 URL（优先 headImgFile，其次 headImgs[0] 的 value）
const userAvatarUrl = ref("");
const updateAvatarUrl = () => {
  const raw = localStorage.getItem("user");
  if (!raw) {
    userAvatarUrl.value = "";
    return;
  }
  try {
    const data = JSON.parse(raw);
    const file = data.headImgFile;
    if (file && typeof file === "string") {
      userAvatarUrl.value = file.trim();
      return;
    }
    const imgs = data.headImgs || [];
    if (imgs.length > 0 && imgs[0].value) {
      userAvatarUrl.value = imgs[0].value;
      return;
    }
    userAvatarUrl.value = "";
  } catch {
    userAvatarUrl.value = "";
  }
};
// 初始化读取；InfoPage 保存后通过自定义事件通知刷新
onMounted(() => {
  updateAvatarUrl();
  window.addEventListener("user-updated", updateAvatarUrl);
});
onUnmounted(() => {
  window.removeEventListener("user-updated", updateAvatarUrl);
});

const noReadCount = ref(0);
const isFullScreen = ref(false);

// const toggleFullScreen = () => {
//   if (!document.fullscreenElement) {
//     document.documentElement.requestFullscreen();
//     isFullScreen.value = true;
//   } else {
//     if (document.exitFullscreen) {
//       document.exitFullscreen();
//       isFullScreen.value = false;
//     }
//   }
// };

const fetchNoReadCount = async () => {
  try {
    const response = await GetMyNoReadCount();
    if (response.code === 200) {
      noReadCount.value = response.data || 0;
    }
  } catch (error) {
    console.error("获取未读消息数量失败:", error);
  }
};
const isVip = ref(false);
const expireTime = ref("");
const GetCurrentUserVipInfos = async () => {
  try {
    const response = await GetCurrentUserVipInfo();
    if (response.code === 200 && response.data) {
      isVip.value = response.data.isVip;
      expireTime.value =
        response.data.expireTime?.match(/\d{4}\/\d{2}\/\d{2}/)?.[0] || "";
      // 同步到 localStorage，供其他组件使用
      localStorage.setItem("isVip", response.data.isVip);
      if (expireTime.value) {
        localStorage.setItem("userExpireTime", expireTime.value);
      }
    } else {
      // response.data 为 null 时清空 isVip
      isVip.value = false;
      localStorage.setItem("isVip", "false");
    }
  } catch (error) {
    console.error("获取用户vip信息失败:", error);
    // 兜底：从 localStorage 读取
    expireTime.value = localStorage.getItem("userExpireTime") || "";
  }
};
// 用户权限列表：只来自登录时 api/Permission/GetUserPermissions 接口的返回
// （登录页调用后存入 localStorage.UserPermissions），
// 前端不再掺入 isSuperAdmin 等写死的角色判断
const userPermissions = ref([]);

// 常驻菜单（按 menuListNew 的 key 匹配，父级和全部子菜单都不做权限过滤）：
// 首页 / AI法律检索 / AI文书生成 / AI风控审查 / 历史任务 / 我的收藏
const ALWAYS_VISIBLE_MENU_KEYS = [
  "dashboard",
  "aiselect",
  "aigenerate",
  "danger",
  "HistoryRecord",
  "collectindex",
];

// 权限检查函数：仅按接口返回的权限列表判断
const hasPermission = (permission) => {
  if (!permission) return true;
  return userPermissions.value.includes(permission);
};

// 侧边栏实际渲染的菜单：常驻菜单原样保留，其余按接口权限过滤（父级和子级分别判断）
const visibleMenuList = computed(() => {
  return menuListNew.value
    .map((menu) => {
      if (ALWAYS_VISIBLE_MENU_KEYS.includes(menu.key)) return menu;
      if (!hasPermission(menu.permission)) return null;
      if (menu.children && menu.children.length > 0) {
        const children = menu.children.filter((child) =>
          hasPermission(child.permission),
        );
        return { ...menu, children };
      }
      return menu;
    })
    .filter(Boolean);
});

// 菜单列表

// const menuList = ref([
//   {
//     key: 'dashboard',
//     title: '首页',
//     icon: DashboardOutlined,
//     permission: 'Menu/Home',
//     children: [
//       { key: 'dashboard', title: '首页', permission: 'Menu/Home/Index', icon: DashboardOutlined }
//     ]
//   },
//   {
//     key: 'my',
//     title: '我的',
//     icon: RobotOutlined,
//     permission: 'Menu/MyMenu',
//     children: [
//       { key: 'my-message', title: '我的消息', permission: 'Menu/MyMenu/MyMessage', icon: MessageOutlined },
//       { key: 'my-ai-chat', title: '我的AI对话', permission: 'Menu/MyMenu/MyAiChat', icon: RobotOutlined },
//       { key: 'my-ai-tasks', title: '我的AI自动任务', permission: 'Menu/MyMenu/MyAiTasks', icon: ScheduleOutlined },
//       { key: 'my-ai-agents', title: '我的可用智能体', permission: 'Menu/MyMenu/MyAiAgents', icon: AppstoreOutlined }
//     ]
//   },
//   {
//     key: 'aimanagement',
//     title: 'AI管理',
//     icon: GitlabOutlined,
//     permission: 'Menu/AIManagement',
//     children: [
//       { key: 'ai-appsmg', title: '智能体管理', permission: 'Menu/AIManagement/AIAppsManagement', icon: RobotOutlined },
//       { key: 'ai-promptsmg', title: '提示词管理', permission: 'Menu/AIManagement/AIPromptsManagement', icon: FileTextOutlined },
//       { key: 'ai-kmssmg', title: '知识库管理', permission: 'Menu/AIManagement/AIKmssManagement', icon: BookOutlined },
//       { key: 'ai-modelmg', title: '模型配置管理', permission: 'Menu/AIManagement/AIModelManagement', icon: SettingOutlined },
//       { key: 'ai-skilltoolmg', title: 'AI技能工具管理', permission: 'Menu/AIManagement/AISkillToolManagement', icon: ToolOutlined }
//     ]
//   },
//   {
//     key: 'legal-portal-group',
//     title: '法律应用',
//     icon: SafetyOutlined,
//     permission: 'Menu/LegalApps',
//     children: [
//       { key: 'legal-portal', title: '法律应用门户', permission: 'Menu/LegalApps/Portal', icon: AppstoreOutlined }
//     ]
//   },
//   {
//     key: 'organizational-management',
//     title: '组织架构',
//     icon: UserOutlined,
//     permission: 'Menu/OrganizationalManagement',
//     children: [
//       { key: 'organizational-position', title: '岗位管理', permission: 'Menu/OrganizationalManagement/PositionManagement', icon: AuditOutlined },
//       { key: 'organizational-department', title: '部门管理', permission: 'Menu/OrganizationalManagement/DepartmentManagement', icon: TeamOutlined }
//     ]
//   },
//   {
//     key: 'user-management',
//     title: '用户管理',
//     icon: UserOutlined,
//     permission: 'Menu/UserManagement',
//     children: [
//       { key: 'user-list', title: '用户列表', permission: 'Menu/UserManagement/UserList', icon: UserOutlined },
//       { key: 'user-role', title: '角色管理', permission: 'Menu/UserManagement/UserRole', icon: SafetyOutlined },
//       { key: 'user-permission', title: '权限管理', permission: 'Menu/UserManagement/UserPermission', icon: KeyOutlined }
//     ]
//   },
//   {
//     key: 'system-settings',
//     title: '系统管理',
//     icon: SettingOutlined,
//     permission: 'Menu/SystemSettings',
//     children: [
//       { key: 'system-announcement', title: '系统公告', permission: 'Menu/SystemSettings/SystemAnnouncement', icon: NotificationOutlined },
//       { key: 'system-dic', title: '系统配置', permission: 'Menu/SystemSettings/SystemDic', icon: SettingOutlined },
//       { key: 'system-tenant', title: '租户管理', permission: 'Menu/SystemSettings/SystemTenant', icon: BankOutlined },
//       { key: 'system-code-generator', title: '代码生成器', permission: 'Menu/SystemSettings/SystemCodeGenerator', icon: CodeOutlined },
//       { key: 'log-management', title: '日志管理', permission: 'Menu/SystemSettings/LogManagement', icon: FileTextOutlined },
//       { key: 'oslog', title: '关键数据变动日志', permission: 'Menu/SystemSettings/OsLog', icon: HistoryOutlined }
//     ]
//   }
// ]);

// 切换主题
// const switchTheme = (theme) => {
//   currentTheme.value = `theme-${theme}`;
//   // 保存主题选择到本地存储
//   localStorage.setItem("app-theme", theme);
// };

// 菜单点击事件
const handleMenuClick = ({ key }) => {
  // 开发中的文书子菜单特殊处理（未登录回首页/已登录显示"持续上线中"）
  if (DEV_DOC_MENU_KEYS.includes(key)) {
    handleDevDocMenu(key);
    return;
  }
  // =========新增校验=========
  // 根据key拿到目标路由
  let targetPath = getRoutePath(key);
  if (!checkTokenBeforeJump(targetPath)) {
    return; // 无token直接阻断后续逻辑
  }
  // =========================
  // console.log(key,'keys2')
  selectedKeys.value = [key];
  activeTabKey.value = [key];
  // 获取页面标题
  const title = pageTitleMap[key] || key;
  if (key === "dashboard") {
    goDashboard();
    openTab(key, title);
    return;
  }
  // console.log(selectedKeys.value,title,'46283')
  // 打开标签页
  openTab(key, title);
  console.log(key, "key1");
  // 根据key跳转到对应路由
  switch (key) {
    case "user-list":
      router.push("/home/user/list");
      break;
    case "user-role":
      router.push("/home/user/role");
      break;
    case "user-permission":
      router.push("/home/user/permission");
      break;
    case "system-dic":
      router.push("/home/system/dic");
      break;
    case "system-announcement":
      router.push("/home/system/announcement");
      break;
    case "my-message":
      router.push("/home/my/message");
      break;
    case "my-ai-chat":
      router.push("/home/my/ai-chat");
      break;
    case "my-ai-tasks":
      router.push("/home/my/ai-tasks");
      break;
    case "my-ai-agents":
      router.push("/home/my/ai-agents");
      break;
    case "log-management":
      router.push("/home/system/log");
      break;
    case "oslog":
      router.push("/home/system/oslog");
      break;
    case "aimanagement":
      router.push("/home/aimanagement");
      break;
    case "ai-appsmg":
      router.push("/home/aimanagement/aiappsmg");
      break;
    case "ai-promptsmg":
      router.push("/home/aimanagement/aipromptsmg");
      break;
    case "ai-kmssmg":
      router.push("/home/aimanagement/aikmssmg"); // 添加知识库管理路由
      break;
    case "ai-modelmg":
      router.push("/home/aimanagement/aimodelmg");
      break;
    case "ai-skilltoolmg":
      router.push("/home/aimanagement/aiskilltoolmg");
      break;
    case "organizational-position":
      router.push("/home/position/management");
      break;
    case "organizational-department":
      router.push("/home/department/management");
      break;
    case "system-tenant":
      router.push("/home/system/tenant");
      break;
    case "system-code-generator":
      router.push("/home/system/code-generator");
      break;
    case "legal-portal":
      router.push("/home/legal/portal");
      break;
    case "legal-portal1":
      router.push("/home/contract-review");
      break;
    case "dashboard":
      router.push("/home");
      break;
    case "handleUserInfo":
      router.push("/home/PersonalCenter");
      break;
    case "HistoryRecord":
      // getComponentByKey(key)
      router.push("/home/HistoryRecord");
      break;
    case "collectindex":
      // getComponentByKey(key)
      router.push("/home/CollectIndex");
      break;
    case "purchaseplan":
      // getComponentByKey(key)
      router.push("/home/PurchasePlan");
      break;
    // case "handleUserInfo":
    //   router.push("/home/PersonalCenter");
    //   break;
    case "aiselect":
      // getComponentByKey(key)
      router.push("/home/SearchHome");
      break;
    case "aikmssmg":
      // getComponentByKey(key)
      router.push("/home/DocumentHome");
      break;
    case "ai-yssws":
      router.push("/home/ElementBased");
      break;
    case "ai-cpws":
      router.push("/home/JudicativePaper");
      break;
    default:
      router.push("/home");
  }
};
// -----新增----
const hasToken = ref(!!localStorage.getItem("token"));

// 抽获取token方法
const checkToken = () => {
  hasToken.value = !!localStorage.getItem("token");
};

// 退出登录
const handleLogout = async () => {
  console.log("用户退出登录");
  await localStorage.removeItem("token");
  await localStorage.removeItem("user");
  await localStorage.removeItem("UserPermissions");
  hasToken.value = false; // 新增
  // 退出后回到免登录首页：展开侧边栏、选中首页并跳 /home（与直接访问 /home 状态一致）
  goDashboard();
};
// 个人中心
const handleUserInfo = () => {
  const key = "handleUserInfo";
  const title = "个人中心";
  selectedKeys.value = [key];
  activeTabKey.value = key;
  openTab(key, title);
  router.push("/home/PersonalCenter");
};
const ALLOWED_THEMES = [
  "enterprise",
  "blackblue",
  "default",
  "green",
  "purple",
  "darkblue",
  "simple-white",
];

onMounted(() => {
  checkToken(); // 新增
  const savedTheme = localStorage.getItem("app-theme");
  if (savedTheme && ALLOWED_THEMES.includes(savedTheme)) {
    currentTheme.value = `theme-${savedTheme}`;
  } else {
    currentTheme.value = "theme-simple-white";
    localStorage.setItem("app-theme", "simple-white");
  }

  const raw = localStorage.getItem("user");
  let parsedUser = null;
  if (raw) {
    try {
      parsedUser = JSON.parse(raw);
      if (parsedUser?.nickName) userInfo.nickName = parsedUser.nickName;
    } catch {
      /* ignore */
    }
  }
  // 菜单权限只认 GetUserPermissions 接口的返回（登录时写入 localStorage）。
  // 数据缺失/无效时保持空列表：除常驻菜单外一律不显示，
  // 不再回退到前端写死的 COMMON/ADMIN 权限集
  const permissionsRaw = localStorage.getItem("UserPermissions");
  if (permissionsRaw) {
    try {
      const permissions = JSON.parse(permissionsRaw);
      if (Array.isArray(permissions)) {
        const tenantId = parsedUser?.tenantId;
        permissions.forEach((item, index) => {
          if (tenantId !== undefined && tenantId !== null) {
            permissions[index] = item.replace(String(tenantId + "/"), "");
          }
        });
        userPermissions.value = permissions;
      }
    } catch {
      /* 权限数据无效，保持空权限 */
    }
  }

  // 未登录（免登录首页）不发用户相关请求，否则接口返回 401
  // 会触发 http.js 全局拦截器强制跳转登录页
  if (hasToken.value) {
    fetchNoReadCount();
    GetCurrentUserVipInfos();
  }
  // 监听支付成功事件，刷新 VIP 信息
  window.addEventListener("vip-paid", () => {
    GetCurrentUserVipInfos();
  });
  document.addEventListener("fullscreenchange", () => {
    isFullScreen.value = !!document.fullscreenElement;
  });
});
</script>

<style>
/* avatar 相关样式统一由内联 style 控制，无需额外全局样式 */
</style>
